
/**
 * Portfolio inner page inifinte scroll
 */

+function($){

  page.initPortfolio = function() {

    if(typeof term_id === "undefined"){
      return ;
    }

    var preventAjax = false;
    $(window).on("scroll", function() {
      var scrollHeight = $(document).height();
      var scrollPos = $(window).height() + $(window).scrollTop();

      if(((scrollHeight - 200) >= scrollPos) / scrollHeight == 0){

        if(preventAjax == true) {
          return false;
        }

        $.ajax({
            url: ajax_url,
            method: "POST",
            data: {
                action: "load_more_portfolio",
                offset: $('.term-item').length,
                term_id: term_id
            },
            dataType: "html",
            context: this,
            beforeSend: function() {
                preventAjax = true;
            }
        })
            .done(function( response ) {
              $('.term-list').append(response);
              if(response.length > 0){
                preventAjax = false;
              }
            });
        }
    });
  }
}(jQuery);

